<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import moment from "moment";
const startOfMonth = moment()
  .clone()
  .startOf("month")
  .format("YYYY-MM-DD");
const endOfMonth = moment()
  .clone()
  .endOf("month")
  .format("YYYY-MM-DD");
export default {
  name: "campaign-period",
  components: {
    VueCtkDateTimePicker
  },
  data() {
    return {
      locations: [],
      dtpicker: { start: startOfMonth, end: endOfMonth },
      form: {
        start: startOfMonth,
        end: endOfMonth,
        mon_start_time: null,
        mon_end_time: null,
        tue_start_time: null,
        tue_end_time: null,
        wed_start_time: null,
        wed_end_time: null,
        thu_start_time: null,
        thu_end_time: null,
        fri_start_time: null,
        fri_end_time: null,
        sat_start_time: null,
        sat_end_time: null,
        sun_start_time: null,
        sun_end_time: null
      }
    };
  },
  computed: {
    getLocations() {
      return this.$store.getters["getLpmLocations"];
    }
  },
  watch: {
    getLocations(newVal) {
      this.locations = newVal;
    }
  }
};
</script>

<template>
  <div>
    <div
      v-if="locations.length === 0"
      class="alert alert-custom alert-light-danger fade show mb-5"
      role="alert"
    >
      <div class="alert-icon"><i class="flaticon-warning"></i></div>
      <div class="alert-text">Please setup locations in Step 1</div>
      <div class="alert-close">
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="ki ki-close"></i></span>
        </button>
      </div>
    </div>
    <v-card
      v-if="locations.length > 0"
      class="mx-auto mb-5 p-5"
      max-width="600"
    >
      <b-form
        v-on:submit.prevent="onSubmit"
        method="POST"
        accept-charset="UTF-8"
        enctype="multipart/form-data"
      >
        <b-row>
          <b-col cols="12">
            <p>
              There are several ways to run LPM campaigns. You can choose a
              start and end date with a maximum budget to be spent between those
              dates, or choose a maximum monthly spend. If you don't want an end
              date on a campaign, just leave the End Date field empty and tell
              us your maximum monthly budget. You can cancel the campaign
              whenever you'd like by finding it on the Campaigns page.
            </p>
            <p>
              Each location or group of locations can have its own specific
              campaign rules. Please select the first location or group of
              locations for your first set of rules.
            </p>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Date Range" class="font-weight-bolder">
              <VueCtkDateTimePicker
                v-model="dtpicker"
                format="YYYY-MM-DD"
                formatted="ll"
                range
                label=""
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            If you want your campaign to be active on certain times on certain
            days you can specify that below. Leaving these fields blank means
            your campaign will be active for all times on all days.
          </b-col>
          <b-col cols="12">
            <b-row>
              <b-col cols="2" class="day-label">
                Monday
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="mon_start_time"
                  v-model="form.mon_start_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="Start Time"
                />
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="mon_end_time"
                  v-model="form.mon_end_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="End Time"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2" class="day-label">
                Tuesday
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="tue_start_time"
                  v-model="form.tue_start_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="Start Time"
                />
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="tue_end_time"
                  v-model="form.tue_end_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="End Time"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2" class="day-label">
                Wednesday
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="wed_start_time"
                  v-model="form.wed_start_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="Start Time"
                />
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="wed_end_time"
                  v-model="form.wed_end_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="End Time"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2" class="day-label">
                Thursday
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="thu_start_time"
                  v-model="form.thu_start_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="Start Time"
                />
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="thu_end_time"
                  v-model="form.thu_end_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="End Time"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2" class="day-label">
                Friday
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="fri_start_time"
                  v-model="form.fri_start_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="Start Time"
                />
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="fri_end_time"
                  v-model="form.fri_end_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="End Time"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2" class="day-label">
                Saturday
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="sat_start_time"
                  v-model="form.sat_start_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="Start Time"
                />
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="sat_end_time"
                  v-model="form.sat_end_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="End Time"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2" class="day-label">
                Sunday
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="sun_start_time"
                  v-model="form.sun_start_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="Start Time"
                />
              </b-col>
              <b-col>
                <VueCtkDateTimePicker
                  id="sun_end_time"
                  v-model="form.sun_end_time"
                  onlyTime
                  format="hh:mm a"
                  formatted="hh:mm a"
                  label="End Time"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-form>
    </v-card>
  </div>
</template>

<style scoped>
.day-label {
  line-height: 40px;
}
</style>
